import { useState } from "react";
import { ConfirmationDialogMulti } from "../../components/DialogCollection";
import ReportPage from "../../pages/ReportPage";
import BlockPage from "../../pages/BlockPage";

const BlockReportPage = (props) => {
  const { params, onClose } = props;
  const { id, type, creator, creatorName } = params;
  const [IsReportPage, setReportPage] = useState(false);
  const [IsBlockPage, setBlockPage] = useState(false);

  return (
    <div>
      <ConfirmationDialogMulti
        title=""
        confirmLabel1="Report"
        confirmLabel2="Block"
        cancelLabel="Back"
        isCustomBtn
        style={{ width: "300px" }}
        show={true}
        onCancel={() => {
          onClose();
        }}
        onConfrim1={() => {
          setReportPage(true);
        }}
        onConfrim2={() => {
          setBlockPage(true);
        }}
      />

      {IsReportPage ? (
        <ReportPage params={{ type: type, id: id }} onClose={() => onClose()} />
      ) : (
        ""
      )}
      {IsBlockPage ? (
        <BlockPage
          params={{ creator: creator, creatorName: creatorName }}
          onClose={() => onClose()}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default BlockReportPage;
